import styled from "styled-components";

const Button = styled.button`
  && {
    width: 100%;
    height: var(--button-medium-height);
    padding: 12px 16px;
    font-size: var(--button-medium-font-size);
    white-space: nowrap;

    @media (min-width: 601px) {
      min-width: var(--button-medium-width);
      height: var(--button-medium-height);
    }
  }
`;

export const StyledButton = (props) => {
  return <Button className="primary" {...props} />;
};
